import React, { useState, useEffect } from 'react'
import { makeStyles, Box } from "@material-ui/core"
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme) => ({
  tag: {
    border: "0px solid",
    borderRadius: "4px",
    fontWeight: 600,
    fontSize: 11,
    padding: "4px 8px",
    width: "fit-content",
  },
}))

export const TagInfrastructure = ({ type }) => {
  const [backgroundColor, setBackgroundColor] = useState('')
  const classes = useStyles();
  const { t } = useTranslation();


  useEffect(() => {
    switch (type) {
      case "unidade_de_negocio":
        setBackgroundColor('#97359E')
        break;

      case "local":
        setBackgroundColor('#448AFF')
        break;

      case "area_de_atuacao":
        setBackgroundColor('#0097BA')
        break;

      default:
        setBackgroundColor('primary.main')
        break
    }
  }, [type])

  return (
    <Box
      bgcolor={`${backgroundColor}`}
      color="white"
      className={classes.tag}
    >
      {t(type)}
    </Box>
  )
}
